import { AnyAction } from 'redux';
import { v4 as uuidv4 } from 'uuid';
import * as actionTypes from '../../../../models/actionTypes';
import { AlchemyInsightModel } from '../../../../models/apiModels';

import { initialUserNoticeState, IUserNotice, IUserNoticeState, UserNotice } from '../../../../models/reduxState';

const handleDismissNotice = (state: IUserNoticeState = initialUserNoticeState, action: AnyAction): IUserNoticeState => {
  const nextState = state.userNotices.map((userNotice) => {
    if (userNotice.noticeId === action.noticeId) {
      return { ...userNotice, isDismissed: true };
    } else {
      return userNotice;
    }
  });
  return {
    ...state,
    userNotices: nextState,
  };
};

const handleFetchUserNoticesSuccess = (state: IUserNoticeState = initialUserNoticeState, action: AnyAction): IUserNoticeState => {
  // The action contains an array of insights that we need to map to UserNotice objects
  const userNotices: IUserNotice[] = action.userNotices.map((insight: AlchemyInsightModel) => {
    const noticeId = uuidv4();
    const userNotice = new UserNotice(noticeId, insight.Description);
    return userNotice;
  });
  return {
    ...state,
    userNotices: userNotices,
  };
};

const handleFetchUserNoticesError = (state: IUserNoticeState = initialUserNoticeState, action: AnyAction): IUserNoticeState => {
  return {
    ...state,
    userNotices: <IUserNotice[]>[],
  };
};

export const UserNoticeReducer = (state: IUserNoticeState = initialUserNoticeState, action: AnyAction): IUserNoticeState => {
  switch (action.type) {
    case actionTypes.DISMISS_NOTICE:
      return handleDismissNotice(state, action);
    case actionTypes.FETCH_USER_NOTICES_SUCCESS:
      return handleFetchUserNoticesSuccess(state, action);
    case actionTypes.FETCH_USER_NOTICES_ERROR:
      return handleFetchUserNoticesError(state, action);
    default:
      return state;
  }
};
